import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("aaf_cart") || "[]");
    } catch {
      return [];
    }
  });
  const [isCartOpen, setCartOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("aaf_cart", JSON.stringify(items));
  }, [items]);

  const add = (product, size) => {
    setItems((prev) => {
      const i = prev.findIndex((p) => p.lookup_key === product.lookup_key && p.size === size);
      if (i >= 0) {
        const next = [...prev];
        next[i] = { ...next[i], qty: next[i].qty + 1 };
        return next;
      }
      return [...prev, { ...product, size, qty: 1 }];
    });
    setCartOpen(true);
  };

  const remove = (lookup_key, size) =>
    setItems((prev) => prev.filter((p) => !(p.lookup_key === lookup_key && p.size === size)));

  const setQty = (lookup_key, size, qty) =>
    setItems((prev) =>
      qty <= 0
        ? prev.filter((p) => !(p.lookup_key === lookup_key && p.size === size))
        : prev.map((p) => (p.lookup_key === lookup_key && p.size === size ? { ...p, qty } : p))
    );

  const clear = () => setItems([]);

  const { count, total } = useMemo(
    () => ({
      count: items.reduce((s, i) => s + i.qty, 0),
      total: items.reduce((s, i) => s + i.qty * i.price, 0),
    }),
    [items]
  );

  return (
    <CartContext.Provider value={{ items, add, remove, setQty, clear, count, total, isCartOpen, setCartOpen }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
